import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import InvoicesActions from "../../../components/User/InvoicesComponents/InvoicesActions";
import InvoicesTable from "../../../components/User/InvoicesComponents/InvoicesTable";

const Invoices = () => {
  return (
    <div>
      <PageHeader text="Обработка на фактури" />
      <InvoicesActions />
      <InvoicesTable />
    </div>
  );
};

export default Invoices;
